import Types from './history-types.store'
import { IHistoryState } from './history-states.store';
import { ActionTree } from 'vuex';
import { IBaseHistoryParameter } from '../../models/base-history-paramter';
import { HistoryResponse, IPropertyHistoryProspectModel } from '../../models/history';
import { Pagination } from "../../models/app-configuration/pagination";

const actions = <ActionTree<IHistoryState, any>>{
  [Types.Get.LIST_OF_HISTORY]: ({ getters, commit }, payload: { param: IBaseHistoryParameter, key: string }) => {
    return getters.service.getListOfHistory(payload.param, { id: payload.param.Id })
      .then(baseListing => {
        const result = new HistoryResponse(baseListing)
        setTimeout(() => commit(Types.Set.LIST_OF_HISTORY, { result, key: payload.key }), 300);
        return Promise.resolve(result);
      })
      .catch(error => Promise.reject(error))
  },
    [Types.Get.RESET_LIST_HISTORY]: ({ commit }, payload: { key: string }) => {
        const result = new HistoryResponse({
            listOfItems: [],
            Ids: [],
            loading: false,
            pagination: new Pagination()
        })
        setTimeout(() => commit(Types.Set.LIST_OF_HISTORY, { result, key: payload.key }), 300);
  }

  , [Types.Get.LIST_CHILDREN]: ({ getters, commit }, payload: { param: IBaseHistoryParameter, childId: number, key: string, index: number }) => {
    return getters.service.getListOfHistory(payload.param, { id: payload.param.Id, childId: payload.childId })
      .then(baseListing => {
        const result = new HistoryResponse(baseListing)
        //setTimeout(() => commit(Types.Set.SET_CHILDREN, { result, key: payload.key, index: payload.index }), 300);
        return Promise.resolve(result);
      })
      .catch(error => Promise.reject(error))
  }

  , [Types.Get.LIST_CHILDREN_BY_PARENT]: ({ getters, commit }, payload: { param: IBaseHistoryParameter, key: string, parent: any }) => {

    const childIndex = getters.source[payload.key].listOfItems.findIndex((child) => child.PersonId === payload.parent.PersonId
      && child.ObjectId === payload.parent.ObjectId)
    if (childIndex !== -1) {
      return getters.service.getListOfHistory(payload.param, { id: payload.param.Id, childId: payload.parent.PersonId })
        .then(baseListing => {
          const result = new HistoryResponse(baseListing)
          setTimeout(() => commit(Types.Set.SET_CHILDREN, { result, key: payload.key, index: childIndex }), 300);
          return Promise.resolve(result);
        })
        .catch(error => Promise.reject(error))
    } else {
      return Promise.reject(`Object with ${payload.parent.PersonId} and ${payload.parent.ObjectId} could not be found`)
    }
  }
    ,[Types.Set.EDIT_PROSPECT_HISTORY]:({ getters, commit }, payload: { paramOrigin: IPropertyHistoryProspectModel, param: IPropertyHistoryProspectModel}) => {
    return getters.service
        .editProspectProperty(payload.paramOrigin, payload.param)
        .then(result => {
            return Promise.resolve(result);
        })
        .catch(error => {        
            if (error.errorCode !== -1000) {
                // commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'OBJECT', message: error.data.msg, id: getters.property.Id }, { root: true })
            }
            return Promise.reject(error);
        });
    }
}

export default actions